import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import ProductCard from '@nmx/template/dist/componentLibrary/modules/ProductCard';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import ShieldWithClock360Arrow from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/ShieldWithClock360Arrow';
import ShieldWithDollarSign from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/ShieldWithDollarSign';
import ShieldWithHeart from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/ShieldWithHeart';
import PaperMoneyStack from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PaperMoneyStack';
// styles
import {
  ColStyled,
  SpanStyled,
} from './styles';

const baseId = 'product-callout-insurance';

const ITEMS = [
  {
    cardId: 'life-insurance-link-card',
    cardIcon: ShieldWithClock360Arrow,
    cardHeading: 'Life insurance',
    cardText: (
      <>
        <SpanStyled>
          <Typography
            component='span'
            weight={400}>
            What&#39;s included:
          </Typography> a payout (that&#39;s guaranteed)<sup>2</sup> when you pass away, and if it&#39;s permanent life insurance, more financial flexibility throughout your life, even in retirement.
        </SpanStyled>
        <SpanStyled disableBottomPadding>
          <Typography
            component='span'
            weight={400}
            disableBottomPadding>
            Best for:
          </Typography> people who want to know that their loved ones will be financially secure, no matter what happens.
        </SpanStyled>
      </>
    ),
    linkUrl: '/life-insurance/',
    topic: 'life insurance.',
  },
  {
    cardId: 'disability-income-insurance-link-card',
    cardIcon: ShieldWithDollarSign,
    cardHeading: 'Disability income insurance',
    cardText: (
      <>
        <SpanStyled>
          <Typography
            component='span'
            weight={400}>
            What&#39;s included:
          </Typography> money to replace a portion of your income, or close the gap between your work coverage, if you&#39;re ever too sick or injured to work.
        </SpanStyled>
        <SpanStyled disableBottomPadding>
          <Typography
            component='span'
            weight={400}
            disableBottomPadding>
            Best for:
          </Typography> individuals (even stay&#45;at&#45;home parents), doctors, dentists, business owners, and employers who want to protect their income, career, or employees.
        </SpanStyled>
      </>
    ),
    linkUrl: '/disability-insurance/',
    topic: 'disability income insurance.',
  },
  {
    cardId: 'long-term-care-planning-link-card',
    cardIcon: ShieldWithHeart,
    cardHeading: (<>Long&#45;term care planning</>),
    cardText: (
      <>
        <SpanStyled>
          <Typography
            component='span'
            weight={400}>
            What&#39;s included:
          </Typography> a comprehensive plan that will help you pay for care if a chronic illness or injury prevents you from properly caring for yourself, no matter your age.
        </SpanStyled>
        <SpanStyled disableBottomPadding>
          <Typography
            component='span'
            weight={400}
            disableBottomPadding>
            Best for:
          </Typography> people (or a loved one) who want the freedom to either stay at home, or get care at a facility of their choice, should they need it.
        </SpanStyled>
      </>
    ),
    linkUrl: '/long-term-care-planning/',
    topic: 'long term care planning.',
  },
  {
    cardId: 'income-annuities-link-card',
    cardIcon: PaperMoneyStack,
    cardHeading: 'Income annuities',
    cardText: (
      <>
        <SpanStyled>
          <Typography
            component='span'
            weight={400}>
            What&#39;s included:
          </Typography> an additional income stream for when you retire that&#39;s guaranteed<sup>3</sup> and that you can never outlive.
        </SpanStyled>
        <SpanStyled disableBottomPadding>
          <Typography
            component='span'
            weight={400}
            disableBottomPadding>
            Best for:
          </Typography> people who want to have an additional stream of retirement income that&#39;s steady and cannot be outlived.
        </SpanStyled>
      </>
    ),
    linkUrl: '/annuities/',
    topic: 'income annuities.',
  },
];

export default () => (
  <SectionContainer
    id='insurance-product-callout-grouping'
    backgroundVariant='lightC'
    themeType='lightTheme'
    moduleName='product-callout-grouping-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col>
        <Typography
          align='center'
          component='h2'
          nextElement='graphic'>
          There are many types of insurance to <WidowBlock>choose from.</WidowBlock>
        </Typography>
      </Col>
    </Row>
    <Row align='center'>
      {ITEMS.map((item) => (
        <ColStyled
          key={`col-${item.cardId}`}
          medium={6}
          large={5}>
          <ProductCard
            cardId={`${baseId}-${item.cardId}`}
            icon={item.cardIcon}
            cardHeading={item.cardHeading}
            cardText={item.cardText}
            linkId={`${baseId}-${item.cardId}-link`}
            linkText='Find out more'
            linkUrl={item.linkUrl}
            ariaLabel={`Find out more about ${item.topic}`}
            backgroundVariant='lightA'
          />
        </ColStyled>
      ))}
    </Row>
  </SectionContainer>
);
